export const environment = {
    production: true,
    http: {
        apiUrl: "https://api.dev.emmadb.com",
        dataUrl: "https://data.dev.emmadb.com",
    },
    mqtt: {
        server: "app.dev.emmadb.com",
        protocol: "wss",
        port: 443,
        path: "/mqtt",
    },
    turnstile: {
        siteKey: "",
    },
    webPush: {
        publicKey: "BGbYuSyxk-mOjeUmPq-yYUxc710gbQAq3mozETXbXefZxMn-32B85GPUlS0OW5tW8Qz28sAqVGNkhJpsjOWJPVM",
    },
    helpUrl: "https://doc.emmadb.com",
};
